import { useTheme } from 'styled-components/macro';
import { getPlainText } from 'utils';
import { Skeleton, SVG } from 'components';
import {
  Button,
  Checkbox,
  Clamp,
  Hint,
  HStack,
  message,
  Text,
} from 'components/ui';
import { copyToClipboard } from 'components/ui/utils';
import { AiBlockWrapper, LoadingWrapper } from './styled';
import { Icons } from 'assets';

type AiEditorBlockProps = {
  title: string;
  content: string;
  loading?: boolean;
  copyIcon?: boolean;
  collapsible?: boolean;
  showEmojiCheckbox?: boolean;
  addEmoji?: boolean;
  onAddEmoji?: (value: boolean) => void;
};

export const AiEditorBlock = ({
  title,
  content,
  loading,
  copyIcon = true,
  collapsible = false,
  showEmojiCheckbox,
  addEmoji,
  onAddEmoji,
}: AiEditorBlockProps) => {
  const theme = useTheme();
  const text = <div dangerouslySetInnerHTML={{ __html: content }} />;

  const handleCopy = async () => {
    try {
      await copyToClipboard(getPlainText(content), true);
      message({
        type: 'success',
        text: 'Текст скопирован',
      });
    } catch {
      message({
        type: 'error',
      });
    }
  };

  return (
    <AiBlockWrapper>
      <HStack justify="space-between">
        <Text variant="heading-4" color="gray.500">
          {title}
        </Text>

        {showEmojiCheckbox && onAddEmoji && (
          <HStack align="center" spacing="xs">
            <Checkbox
              size="s"
              checked={addEmoji}
              onChange={(e) => onAddEmoji(e.target.checked)}
              disabled={loading}
            />
            <Text>Эмодзи</Text>
          </HStack>
        )}
      </HStack>

      <LoadingWrapper $loading={!!loading}>
        {loading && <Skeleton overlay />}
        {collapsible ? (
          <Clamp
            fadeColor={loading ? theme.colors.gray[100] : theme.colors.white}
          >
            {text}
          </Clamp>
        ) : (
          <Text
            color="gray.800"
            style={loading ? { opacity: '60%' } : undefined}
          >
            {text}
          </Text>
        )}
      </LoadingWrapper>

      {!loading && copyIcon && (
        <HStack align="center" justify="flex-end">
          <Hint content="Скопировать текст">
            <Button
              onClick={handleCopy}
              mode="neutral"
              variant="ghost"
              size="xs"
              iconButton={<SVG src={Icons.Clone} />}
            />
          </Hint>
        </HStack>
      )}
    </AiBlockWrapper>
  );
};
